import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { hasValue } from '@progress-fe/core';
import { Box, Grid } from '@chakra-ui/react';
import { sum } from 'lodash-es';
import { InputNumber } from '../../../../inputs';
const CompositionSummaryFC = ({ value, suffix }) => {
    const calculateSum = () => {
        return sum(value.map((i) => (hasValue(i.sampleValue) ? Number(i.sampleValue) : undefined)));
    };
    return (_jsxs(Grid, { p: "6px 0 0 0", gridTemplateColumns: "180px 1fr", alignItems: "center", children: [_jsx(Box, { p: "0 0 0 2px", children: "\u0418\u0442\u043E\u0433\u043E" }), _jsx(InputNumber, { disabled: true, size: "xs", variant: "outline", sx: { width: '100%' }, value: calculateSum(), rightElement: suffix ? _jsx(_Fragment, { children: suffix }) : undefined })] }));
};
export const CompositionSummary = memo(CompositionSummaryFC);
//# sourceMappingURL=CompositionSummary.js.map